import type { Components, Theme } from "@mui/material/styles";

export const MuiCheckbox: Components<Theme>["MuiCheckbox"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(0.5),
      color: theme.palette.warning.main,

      "&.Mui-checked": {
        color: theme.palette.success.main,
      },

      "&.MuiCheckbox-indeterminate": {
        color: theme.palette.warning.main,
      },
    }),
  },
};
